"use client";

// Pub-sub signal so chrome (dock, widget) can hide while podcast audio plays.

import { useSyncExternalStore } from "react";

let active = false;
const listeners = new Set<() => void>();

export function setPodcastActive(value: boolean): void {
  if (active === value) return;
  active = value;
  for (const l of listeners) l();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): boolean {
  return active;
}

function getServerSnapshot(): boolean {
  return false;
}

export function usePodcastActive(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
